<div class="form-group-custom">
  <label for="inputAirportHoliday" class="input-group-zeus__label">Partenza da</label>
  <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
       id="inputAiportHoliday-dropdown">
    <input type="text" class="form-control-custom" id="inputAirportHoliday"
          [placeholder]="selectedFirstAirport
          ? (selectedFirstAirport | getDataFromMapping: (selectedFirstAirport > 1000000 ? 'airportId' : 'destination') | async)?.Name + (selectedAirportInner?.length > 1 ? ' + ' + (selectedAirportInner.length - 1) : '')
          : 'Seleziona partenza'"
           aria-label="Partenza"
           aria-describedby="basic-addon3"
           (click)="open()" readonly>
    <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
      <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i
        class="icon-pin"></i></span>
    </div>
  </div>
</div>
